import { useLang } from '../utils/hooks'
import { langLogin } from '../assets/langLogin'
import { PayPalScriptProvider } from '@paypal/react-paypal-js'
import ButtonWrapper from './ButtonWrapper'

const Subscribe = ({ onConfirmSubscribe, onCancel }) => {
  const { lang } = useLang()
  const choosenLang = lang === 'fr' ? langLogin.fr : langLogin.eng

  const style = {
    shape: 'rect',
    color: 'silver',
    layout: 'vertical',
    label: 'paypal',
  }
  const currency = 'EUR'
  const amount = process.env.REACT_APP_SUBSCRIBE_PRICE_PER_YEAR

  const handlePaypal = (isOk) => {
    onConfirmSubscribe(isOk)
  }

  return (
    <div>
      <div className="block">
        <p>
          {choosenLang.subscribePriceMention1}{' '}
          <span className="has-text-weight-bold">
            {process.env.REACT_APP_SUBSCRIBE_PRICE_PER_YEAR}{' '}
          </span>
          {choosenLang.subscribePriceMention2}
        </p>
      </div>
      <div style={{ maxWidth: '750px', minHeight: '200px' }}>
        <PayPalScriptProvider
          options={{
            'client-id':
              'ASS__PDJWKRxtRxDxpZaImmdrY5No9Pn5LJ5_pqOFQIQQolBYpDRAlfCOw4v7I_R21Lda32HCoCseBOu',
            components: 'buttons',
            currency: 'EUR',
          }}
        >
          <ButtonWrapper
            currency={currency}
            showSpinner={false}
            style={style}
            amount={amount}
            handlePaypal={handlePaypal}
          />
        </PayPalScriptProvider>
      </div>
      <div className="field is-grouped">
        <p className="control">
          <button className="button is-light " onClick={onCancel}>
            {choosenLang.cancel}
          </button>
        </p>
      </div>
    </div>
  )
}

export default Subscribe
